module.exports = __webpack_public_path__ + "fb94f9cc0fb638bfbd930e767205567f.fbx";